// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

// Internal Dependencies
import PillButton from '../../common/Button/PillButton';
import { MallMapManageButtons } from '../../../common/constants';
import { useMallMapStore } from '../../../hook/useMallMapStore';

const { MANAGE_LEVELS, MANAGE_WAYPOINTS, MANAGE_LINKS } = MallMapManageButtons;

const MallNavigationHeader = ({ pageName, mallMapStatus, onOpenModal }) => {
  const {
    selectedButton,
    updateSelectedButton,
    setSelectedWaypoint,
    showForm,
    toggleShowForm,
    isEdgeViewMode,
    toggleEdgeViewMode,
    isWaypointTextVisible,
    toggleWaypointTextVisible,
  } = useMallMapStore((state) => state);

  const manageSelectedBtnHandler = (selectedBtn) => {
    updateSelectedButton(selectedBtn);

    if (selectedBtn !== MANAGE_WAYPOINTS) {
      setSelectedWaypoint(null);
    }
  };

  const manageLevelHandler = (selectedBtn) => {
    manageSelectedBtnHandler(selectedBtn);
    onOpenModal();
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <Typography className="font-weight-normal" variant="h6">
          Mall Navigation:
          <u className="font-weight-bold ml-2">{pageName}</u>
        </Typography>

        <div className="d-flex align-items-center">
          <Typography className="font-weight-normal m-0 mr-2" variant="h6">Mall Map Status:</Typography>
          <PillButton text={mallMapStatus} btnStyle={mallMapStatus} />
        </div>
      </div>

      <div className="d-flex align-items-center mt-2">
        <div className="border-right pr-4">
          <Typography className="mb-1">Levels:</Typography>
          <PillButton
            text="Manage Levels"
            selected={selectedButton === MANAGE_LEVELS}
            onClick={() => manageLevelHandler(MANAGE_LEVELS)}
          />
        </div>

        <div className="border-right px-4">
          <Typography className="mb-1">Select operation:</Typography>
          <PillButton
            text="Manage Waypoints"
            className="mr-2"
            selected={selectedButton === MANAGE_WAYPOINTS}
            onClick={() => manageSelectedBtnHandler(MANAGE_WAYPOINTS)}
          />
          <PillButton
            text="Manage Links"
            selected={selectedButton === MANAGE_LINKS}
            onClick={() => manageSelectedBtnHandler(MANAGE_LINKS)}
          />
        </div>

        <div className="pl-4">
          <Typography className="mb-1">Select sub-operation:</Typography>
          <PillButton
            disabled={![MANAGE_WAYPOINTS, MANAGE_LINKS].includes(selectedButton)}
            text={`${showForm ? 'Hide' : 'Show'} Form`}
            onClick={toggleShowForm}
          />
          { selectedButton === MANAGE_WAYPOINTS && (
            <PillButton
              className="ml-2"
              text={`${isWaypointTextVisible ? 'Hide' : 'Show'} Waypoint Text`}
              onClick={toggleWaypointTextVisible}
            />
          )}
          { selectedButton === MANAGE_LINKS && (
            <PillButton
              className="ml-2"
              text={`${isEdgeViewMode ? 'Add' : 'View'} Edge Mode`}
              onClick={toggleEdgeViewMode}
            />
          )}
        </div>
      </div>
    </div>
  );
};

MallNavigationHeader.propTypes = {
  pageName:      PropTypes.string.isRequired,
  mallMapStatus: PropTypes.string.isRequired,
  onOpenModal:   PropTypes.func.isRequired,
};

export default MallNavigationHeader;
